<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Facilities"
                   :links="[{title:'Home', url:'/'},{title:'Facilities'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Facility</div>
          <blockquote class="about-message">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci aspernatur est ipsum iste molestiae,
              officiis possimus praesentium quas quibusdam repellat sunt voluptatibus. Dignissimos eum exercitationem
              nam provident quidem quo ut.</p>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/facilities/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Facility",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
  },

}
</script>
<style lang="scss" scoped/>
